<template>
  <div v-bind="$attrs" class="whitespace-pre-wrap">
    {{ address }}
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  inheritAttrs: false,
  props: {
    address: {
      type: Object,
      default: null,
    },
    defaultValue: {
      type: String,
      default: '–',
    }
  },
  setup(props) {
    function filter(items) {
      return items.filter(item => item);
    }

    function join(items, separator) {
      return filter(items).join(separator);
    }

    const address = computed(() => {
      if (!props.address) return props.defaultValue;
      return format(props.address);
    });

    function format(address) {
      return join([
        join([address.first_name, address.last_name], ' '),
        address.company,
        address.street,
        join([address.postal_code, address.city], ' '),
        address.country,
      ], '\n');
    }

    return {
      address,
    }
  }
}
</script>
